// Shared look for the player's own profile page. Matches the public player
// preview (pages/preview/ProfilePreviewPages.jsx): white cards on light pages,
// navy cards on dark, with a bold title row.

export const CARD = 'bg-jp-card rounded-2xl border border-jp-outline/70 shadow-sm p-5 sm:p-6';

export const CardTitle = ({ title, children }) => (
  <div className="flex items-center justify-between gap-3 mb-4">
    <h2 className="text-lg font-extrabold text-jp-ink">{title}</h2>
    {children}
  </div>
);

export const EditButton = ({ onClick, children = 'Edit' }) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex items-center gap-1.5 text-sm font-semibold text-jp-accent hover:underline underline-offset-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent rounded"
  >
    {children}
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
    </svg>
  </button>
);

// Label/value pairs, laid out like the preview's "Player Information" grid
export const InfoGrid = ({ items }) => (
  <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-4">
    {items.map(({ label, value }) => (
      <div key={label} className="min-w-0">
        <dt className="text-jp-muted text-[10px] font-bold uppercase tracking-widest mb-1">{label}</dt>
        <dd className="text-jp-ink text-sm font-semibold truncate">{value || '-'}</dd>
      </div>
    ))}
  </dl>
);

// Bulleted list with accent dots, as on the preview's awards card
export const BulletList = ({ items, empty }) =>
  items.length > 0 ? (
    <ul className="space-y-2 text-jp-muted text-sm">
      {items.map((item, i) => (
        <li key={i} className="flex gap-2">
          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-jp-accent flex-shrink-0" aria-hidden="true"></span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  ) : (
    <p className="text-jp-muted/80 text-sm">{empty}</p>
  );

export const SECONDARY_BUTTON =
  'px-3 py-1.5 rounded-lg border border-jp-line bg-jp-section hover:bg-jp-line text-jp-ink text-sm font-medium transition-colors';
